import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const About = () => {
  return (
    <div className="min-h-screen bg-white py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-black mb-8">
          Acerca de Video Vault
        </h1>

        <div className="space-y-6 text-gray-700 leading-relaxed">
          <p className="text-lg">
            Video Vault es una herramienta web diseñada para ayudar a las personas a guardar videos 
            públicos disponibles en Instagram y Facebook cuando necesitan verlos sin conexión, archivarlos
            de forma personal o conservar contenido propio (o con permiso del autor). Nuestro objetivo 
            es ofrecer una experiencia simple, con explicaciones claras y un enfoque responsable.
          </p>

          <Card className="border-2 mt-8">
            <CardHeader>
              <CardTitle className="text-2xl">¿Qué hace esta herramienta?</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700">
                Cuando pegás un enlace de un video público, el sistema intenta identificar las opciones 
                disponibles para ese enlace y presentarte alternativas de descarga compatibles. Esto puede 
                incluir distintas calidades o formatos según la disponibilidad del video y el tipo de publicación.
              </p>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-2xl">¿Qué NO hacemos?</CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>No alojamos videos en nuestros servidores.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>No copiamos ni republicamos contenido.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>No pedimos cuenta para usar la herramienta.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>No guardamos tu historial personal en nuestros servidores; solo puede existir historial local en tu navegador.</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-2">
            <CardHeader>
              <CardTitle className="text-2xl">Contenido que aporta valor</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700 mb-4">Además de la herramienta, mantenemos:</p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Guías paso a paso para distintos dispositivos.</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Preguntas frecuentes y solución de problemas típicos (audio, calidad, enlaces inválidos, etc.).</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-black font-bold mt-1">•</span>
                  <span>Actualizaciones cuando cambian formatos o estructuras de enlaces.</span>
                </li>
              </ul>
            </CardContent>
          </Card>

          <Card className="border-2 bg-gray-50">
            <CardHeader>
              <CardTitle className="text-2xl">Uso responsable y derechos</CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-700">
                Recomendamos usar Video Vault para descargar contenido propio o contenido que tengás 
                permiso de guardar, y únicamente cuando el video sea público. Si sos propietario de 
                contenido y querés solicitar revisión o retiro de algún enlace, contamos con un canal 
                de contacto.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default About;
